<template>
    <span>
        <router-link :to="linkPath" class="custom-a-blue" :target="shouldOpenInNewTab ? '_blank' : '_self'">
            {{ linkText }}
        </router-link>
    </span>
</template>

<script>
export default {
    name: 'GridLinkRenderer',
    data() {
        return {
            linkPath: '',
            linkText: '',
            shouldOpenInNewTab: false
        };
    },
    beforeMount() {
        this.linkPath = this.params.value.linkPath;
        this.linkText = this.params.value.linkText;
        this.shouldOpenInNewTab = this.params.value.shouldOpenInNewTab;
    }
};
</script>
